import { render } from "./spinner.vue?vue&type=template&id=562fa771&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=562fa771&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562fa771"]])

export default __exports__